// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2OW6H","filesListContainer":"PosDisputesFiles_filesListContainer__2N0hm","filesButton":"PosDisputesFiles_filesButton__2ocd8"};